export default __webpack_public_path__ + "static/media/home_bubble_bg.c60dca2d.png";